import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import ShowAllRolePermissions from '../../components/SetupSubPageComps/RolePermissionsComps/ShowAllRolePermissions';
import RolePermissionProvider from '../../contexts/RolePermissionProvider';

const RolePermissions = () => {
  // rendering role permissions page component here
  return (
    <>
      <PageTitle title='Role Permissions' />

      <RolePermissionProvider>
        <ShowAllRolePermissions />
      </RolePermissionProvider>
    </>
  );
};

export default RolePermissions;
